import React, {FC} from "react"
import {TableHeader, TableHeaderCell, TableRow} from "semantic-ui-react"
import { FormattedMessage } from "react-intl"
import {DatepickerHint} from "../../datepicker/datepicker-hint"


export const CreatorFamHeader: FC = () => {
    return (
        <TableHeader>
            <TableRow>
                <TableHeaderCell className="sticky-header" collapsing>&nbsp;</TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center"><FormattedMessage id="creator.column.family.id"/>&nbsp;<span style={{color: "red"}}>*</span></TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center" collapsing><FormattedMessage id="creator.column.family.husbandId"/>&nbsp;<span style={{color: "red"}}>*</span></TableHeaderCell>
                <TableHeaderCell className="sticky-header" textAlign="center" collapsing><FormattedMessage id="creator.column.family.wifeId"/>&nbsp;<span style={{color: "red"}}>*</span></TableHeaderCell>
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.family.marriageDate"/><DatepickerHint/></TableHeaderCell>
                <TableHeaderCell className="sticky-header" width={2}><FormattedMessage id="creator.column.family.marriagePlace"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header"><FormattedMessage id="creator.column.family.notes"/></TableHeaderCell>
                <TableHeaderCell className="sticky-header remove-column" collapsing>&nbsp;</TableHeaderCell>
            </TableRow>
        </TableHeader>
    )
}
